import { AbcRiskBandsConfig, HaloRiskBandsConfig, SimpleRiskBandsConfig } from "../schema";
import { defaultAbcArchetypes } from "./archetypes/abc";
import { defaultHaloArchetypes } from "./archetypes/halo";
import { defaultSimpleStructuralArchetypes } from "./archetypes/structural";

const baseConfig: Pick<AbcRiskBandsConfig, "quickBatch"> = {
  quickBatch: {
    maxAddresses: 30,
  },
};

export const defaultAbcRiskBandsConfig: AbcRiskBandsConfig = {
  ...baseConfig,
  mode: "abc",
  archetypes: defaultAbcArchetypes,
  maxLetter: "C",
};

export const defaultHaloRiskBandsConfig: HaloRiskBandsConfig = {
  ...baseConfig,
  mode: "halo",
  archetypes: defaultHaloArchetypes,
  maxLetter: "E",
};

export const defaultSimpleStructuralRiskBandsConfig: SimpleRiskBandsConfig = {
  ...baseConfig,
  mode: "simple",
  archetypes: defaultSimpleStructuralArchetypes,
  maxLetter: "C",
};
